<div class="wetter_content_container">
  <h3>Inforadio</h3>
  <div class="bericht-text-container">
    <span class="bericht-text-sub-label">Schlagzeile</span>
    <p>{{infoRadioTexte?.schlagzeile}}</p>
  </div>
  <h3>Vorhersage</h3>
  <div class="bericht-text-container">
    <span
      class="bericht-text-sub-label">{{infoRadioTexte?.langwetterVorhersage?.tag00?.datum | date: 'EEE dd.MM'}}</span>
    <p>{{infoRadioTexte?.langwetterVorhersage?.tag00?.kurzbeschreibung}}</p>
  </div>
  <div class="bericht-text-container">
    <span
      class="bericht-text-sub-label">Nacht zu {{infoRadioTexte?.langwetterVorhersage?.nachtZuTag01?.datum | date: 'EEE dd.MM'}}</span>
    <p>{{infoRadioTexte?.langwetterVorhersage?.nachtZuTag01?.kurzbeschreibung}}</p>
    <span
      class="bericht-text-sub-label">{{infoRadioTexte?.langwetterVorhersage?.tag01?.datum | date: 'EEE dd.MM'}}</span>
    <p>{{infoRadioTexte?.langwetterVorhersage?.tag01?.kurzbeschreibung}}</p>
  </div>
</div>
